import { EntidadesAdministradoras } from './../../rascunho';
export interface IRascunhoIdentificacao {
    cnes: string;
    cnpj: string;
    cpf: string;
    id: string;
    nomeFantasia: string;
    statuscodigo: string;
    statusdescricao: string;
    usuarioAlteracao: string;
    usuarioCriacao: string;
}

export class RascunhoIdentificacaoModel {
    cnes: string;
    cnpj: string;
    cpf: string;
    id: string;
    nomeFantasia: string;
    statuscodigo: string;
    statusdescricao: string;
    usuarioAlteracao: string;
    usuarioCriacao: string;

    constructor(obj?: IRascunhoIdentificacao) {
        this.cnes = obj && obj.cnes ? obj.cnes : '';
        this.cnpj = obj && obj.cnpj ? obj.cnpj : '';
        this.cpf = obj && obj.cpf ? obj.cpf : '';
        this.id = obj && obj.id ? obj.id : '';
        this.nomeFantasia = obj && obj.nomeFantasia ? obj.nomeFantasia : '';
        this.statuscodigo = obj && obj.statuscodigo ? obj.statuscodigo : '';
        this.statusdescricao = obj && obj.statusdescricao ? obj.statusdescricao : '';
        this.usuarioAlteracao = obj && obj.usuarioAlteracao ? obj.usuarioAlteracao : '';
        this.usuarioCriacao = obj && obj.usuarioCriacao ? obj.usuarioCriacao : '';
    }
}

export interface IEntidadesAdministradoras {
    bairro: string;
    cep: string;
    cnpj: string;
    complemento: string;
    endereco: string;
    id: string;
    logradouro: string;
    municipio: string;
    // naturezaJuridica: NaturezaJuridica;
    nome: string;
    regiaoSaude: string;
    telefone: string;
    // tipo: TipoEntidadeAdm;
}

export class IIdentificacaoPrincipal {
    bairro: string;
    cep: string;
    cnpj: string;
    codigoMunicipioIBGE: string;
    codigoNaturezaJuridica: string;
    codigoUf: string;
    codigoUnidade: string;
    complementoEndereco: string;
    cpf: string;
    email: string;
    latitude: string;
    logradouro: string;
    longitude: string;
    municipio: string;
    nomeEmpresarial: string;
    nomeFantasia: string;
    numeroEndereco: string;
    telefone: string;
    tipoEstrutura: string;
    tipoEstruturaid: string;
    abrangencia?: string;
    entidadesAdministradoras?: Array<EntidadesAdministradoras>
}

export interface ITipoEstrutura {
    codigo: string;
    descricao: string;
}

export class IdentificacaoPrincipalModel {
    bairro: string;
    cep: string;
    cnpj: string;
    codigoMunicipioIBGE: string;
    codigoNaturezaJuridica: string;
    codigoUf: string;
    codigoUnidade: string;
    complementoEndereco: string;
    cpf: string;
    email: string;
    // entidadesAdministradoras: [IEntidadesAdministradoras];
    latitude: string;
    logradouro: string;
    longitude: string;
    municipio: string;
    nomeEmpresarial: string;
    nomeFantasia: string;
    numeroEndereco: string;
    telefone: string;
    tipoEstrutura: string;
    tipoEstruturaid: string;
    numeroPrincipal: string;

    constructor(obj: IIdentificacaoPrincipal) {
        this.bairro = obj.bairro ? obj.bairro : '-';
        this.cep = obj.cep ? obj.cep : '-';
        this.cnpj = obj.cnpj ? obj.cnpj : '-';
        this.codigoMunicipioIBGE = obj.codigoMunicipioIBGE ? obj.codigoMunicipioIBGE : '-';
        this.codigoNaturezaJuridica = obj.codigoNaturezaJuridica ? obj.codigoNaturezaJuridica : '-';
        this.codigoUf = obj.codigoUf ? obj.codigoUf : '-';
        this.codigoUnidade = obj.codigoUnidade ? obj.codigoUnidade : '-';
        this.complementoEndereco = obj.complementoEndereco ? obj.complementoEndereco : '-';
        this.cpf = obj.cpf ? obj.cpf : '-';
        this.email = obj.email ? obj.email : '-';
        this.latitude = obj.latitude ? obj.latitude : '-';
        this.logradouro = obj.logradouro ? obj.logradouro : '-';
        this.longitude = obj.longitude ? obj.longitude : '-';
        this.municipio = obj.municipio ? obj.municipio : '-';
        this.nomeEmpresarial = obj.nomeEmpresarial ? obj.nomeEmpresarial : '-';
        this.nomeFantasia = obj.nomeFantasia ? obj.nomeFantasia : '-';
        this.numeroEndereco = obj.numeroEndereco ? obj.numeroEndereco : '-';
        this.telefone = obj.telefone ? obj.telefone : '-';
        this.tipoEstrutura = obj.tipoEstrutura ? obj.tipoEstrutura : '-';
        this.tipoEstruturaid = obj.tipoEstruturaid ? obj.tipoEstruturaid : '-';
    }
}

export interface IEstabPrincipal {
    cnes: string;
    cnpjCpf: string;
    nomeEmpresarial: string;
    nomeFantasia: string;
    naturezaJuridica: string;
    telefone: string;
    email: string;
    // nomeEmpresarialMantenedora: string;
    naturezaJuridicaMantenedora: string;
    cnpjMantenedora: string;
    cep: string;
    logradouro: string;
    numeroEndereco: string;
    complemento: string;
    bairro: string;
    siglaUf: string;
    ufIbge: string;
    uf: string;
    codigoUf: string;
    idMunicipio: string;
    municipio: string;
    codigoIbgeMunicipio: string;
    tipoEstrutura: string;
    tipoEstruturaId: string;
    latitude: string;
    longitude: string;
}

export class EstabPrincipalModel {
    cnes: string;
    cnpjCpf: string;
    nomeEmpresarial: string;
    nomeFantasia: string;
    naturezaJuridica: string;
    telefone: string;
    email: string;
    // nomeEmpresarial: string;
    naturezaJuridicaMantenedora: string;
    cnpjMantenedora: string;
    cep: string;
    logradouro: string;
    numeroEndereco: string;
    complemento: string;
    bairro: string;
    siglaUf: string;
    ufIbge: string;
    uf: string;
    codigoUf: string;
    idMunicipio: string;
    codigoIbgeMunicipio: string;
    municipio: string;
    tipoEstrutura: string;
    tipoEstruturaId: string;
    latitude: string;
    longitude: string;

    constructor(obj: IEstabPrincipal) {
        this.cnes = obj.cnpjCpf ? obj.cnpjCpf : '';
        this.cnpjCpf = obj.cnpjCpf ? obj.cnpjCpf : '';
        this.nomeEmpresarial = obj.nomeEmpresarial ? obj.nomeEmpresarial : '';
        this.nomeFantasia = obj.nomeFantasia ? obj.nomeFantasia : '';
        this.naturezaJuridica = obj.naturezaJuridica ? obj.naturezaJuridica : '';
        this.telefone = obj.telefone ? obj.telefone : '';
        this.email = obj.email ? obj.email : '';
        // this.nomeEmpresarialMantenedora = obj.nomeEmpresarialMantenedora ? obj.nomeEmpresarialMantenedora : '';
        this.naturezaJuridicaMantenedora = obj.naturezaJuridicaMantenedora ? obj.naturezaJuridicaMantenedora : '';
        this.cnpjMantenedora = obj.cnpjMantenedora ? obj.cnpjMantenedora : '';
        this.cep = obj.cep ? obj.cep : '';
        this.logradouro = obj.logradouro ? obj.logradouro : '';
        this.numeroEndereco = obj.numeroEndereco ? obj.numeroEndereco : '';
        this.complemento = obj.complemento ? obj.complemento : '';
        this.bairro = obj.bairro ? obj.bairro : '';
        this.siglaUf = obj.siglaUf ? obj.siglaUf : '';
        this.ufIbge = obj.ufIbge ? obj.ufIbge : '';
        this.uf = obj.uf ? obj.uf : '';
        this.codigoUf = obj.codigoUf ? obj.codigoUf : '';
        this.codigoIbgeMunicipio = obj.codigoIbgeMunicipio ? obj.codigoIbgeMunicipio : '';
        this.municipio = obj.municipio ? obj.municipio : '';
        this.tipoEstrutura = obj.tipoEstrutura ? obj.tipoEstrutura : '';
        this.tipoEstruturaId = obj.tipoEstruturaId ? obj.tipoEstruturaId : '';
        this.latitude = obj.latitude ? obj.latitude : '';
        this.longitude = obj.longitude ? obj.longitude : '';
    }
}
